import React, {Component} from 'react'
import Paper from 'material-ui/Paper'
import {MenuItem} from 'material-ui/Menu'
import axios from 'axios'

import {server} from './constants'


class AutoComplete extends Component {
    state = {
        suggestions: []
    };


    getSuggestion = (word) => {
        if (word === '') {
            this.setState({suggestions:[]});
        }else {

            let self = this;
            axios.get(server + 'dictionary-api/autocomplete/', {
                params: {
                    find_it: word
                }
            })
                .then(function (response) {
                    if (response.data.length > 0) {
                        self.setState({suggestions: response.data[0].Word})
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        }
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.props.value) {
            this.getSuggestion(nextProps.value)
        }
    }
    onClick = (e, autosuggestion) => {
        this.props.callback(autosuggestion)
    };

    render() {
        const suggestions = this.state.suggestions;

        if(this.props.listen) {
            return (
                <Paper>

                    {suggestions.map((autosuggestion) => {
                        return (
                            <MenuItem
                                key={autosuggestion}
                                selected={autosuggestion === this.props.value}
                                onClick={e =>this.onClick(e, autosuggestion)}
                            >
                                {autosuggestion}
                            </MenuItem>
                        )
                    })
                    }
                </Paper>
            )
        }else {
            return null
        }
    }
}

export default AutoComplete


// WEBPACK FOOTER //
// ./src/autocomplete.js